/* ACCOUNT MODAL — profile + DataForSEO API integration. Exact port of code.txt
   AccountModal; saving hits PUT /api/me/dataforseo (encrypted server-side, never
   returned). When a SERP run is pending without credentials, the magenta banner shows. */

import { Card, SectionTitle, BtnPrimary, BtnNeutral, T, MONO, FONT, escapeHtml } from "../ui.js";
import { AioLabel } from "../ui.js";
import { api } from "../api.js";

export function renderAccountModal(app, { user, hasDfs, dfsLocation, promptForSerp, onSaveDfs, onSignOut, onClose }) {
  const wrap = document.createElement("div");
  wrap.id = "account-modal";
  const saved = dfsLocation != null ? String(dfsLocation) : "2840";
  wrap.innerHTML = `
    <div id="am-backdrop" style="position:fixed;inset:0;background:rgba(10,10,11,0.4);display:flex;align-items:center;justify-content:center;z-index:50;font-family:${FONT}">
      ${Card(`
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">
          <div style="font-weight:800;font-size:15px">Account</div>
          <button id="am-close" style="border:none;background:transparent;color:${T.muted};font-size:16px;cursor:pointer;padding:0">✕</button>
        </div>
        <div style="display:flex;align-items:center;justify-content:space-between;background:${T.bg};border:1px solid ${T.lineSoft};border-radius:11px;padding:10px 12px;margin-bottom:18px">
          <div>
            <div style="font-size:12.5px;font-weight:700;color:${T.ink}">${escapeHtml(user.email)}</div>
            <div style="font-size:10.5px;color:${T.muted}">Signed in with ${user.provider === "google" ? "Google" : "email"}</div>
          </div>
          ${BtnNeutral("Sign out", { small: true, attrs: 'id="am-signout"' })}
        </div>
        ${promptForSerp && !hasDfs ? `
          <div style="background:${T.magentaSoft};border:1px solid rgba(245,15,175,0.25);border-radius:11px;padding:10px 12px;margin-bottom:12px;font-size:12px;color:${T.ink};font-weight:600">
            ${AioLabel("Running with SERP needs a DataForSEO API key — add it below and you'll continue straight to the analysis.", 11)}
          </div>` : ""}
        ${SectionTitle("DataForSEO API integration")}
        <p style="font-size:12px;color:${T.sub};line-height:1.6;margin:0 0 12px">
          With DataForSEO credentials, every analysis also checks the live SERP for your top 100 keywords (by impressions, to keep API cost bounded) and reports, per keyword, whether an <b style="color:${T.magenta}">AI Overview</b> was shown and whether your site is cited in it. Without credentials the tool runs on your Search Console exports alone.
        </p>
        <div style="display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:10px;margin-bottom:10px">
          <input id="am-login" placeholder="API login" style="padding:9px 11px;border-radius:10px;border:1px solid ${T.line};background:${T.bg};font-family:${MONO};font-size:12px;color:${T.ink};outline:none;box-sizing:border-box"/>
          <input id="am-password" placeholder="API password" type="password" style="padding:9px 11px;border-radius:10px;border:1px solid ${T.line};background:${T.bg};font-family:${MONO};font-size:12px;color:${T.ink};outline:none;box-sizing:border-box"/>
        </div>
        <div style="display:flex;gap:10px;align-items:center;margin-bottom:14px">
          <span style="font-size:11.5px;color:${T.muted};font-weight:600">SERP location code</span>
          <input id="am-location" value="${saved}" style="width:90px;padding:7px 10px;border-radius:9px;border:1px solid ${T.line};background:${T.bg};font-family:${MONO};font-size:12px;color:${T.ink};outline:none"/>
          <span style="font-size:10.5px;color:${T.muted}">2840 = US · 2356 = India</span>
        </div>
        <div style="display:flex;gap:10px">
          ${BtnPrimary(hasDfs ? "Update Integration" : "Save Integration", { attrs: 'id="am-save"', style: "justify-content:center" })}
          ${hasDfs ? BtnNeutral("Remove", { attrs: 'id="am-remove"' }) : ""}
        </div>
        <div id="am-err" style="display:none;font-size:11.5px;color:${T.red};margin-top:10px"></div>
        <div style="font-size:10.5px;color:${T.muted};margin-top:12px;line-height:1.5">Credentials are stored in your workspace and sent only to api.dataforseo.com. If your environment blocks that request, the analysis simply runs without SERP data.</div>`,
      { attrs: 'id="am-card"', style: "width:460px;max-width:92vw;padding:24px" })}
    </div>`;
  app.appendChild(wrap);

  const q = sel => wrap.querySelector(sel);
  const close = () => wrap.remove();
  q("#am-backdrop").addEventListener("click", e => { if (e.target.id === "am-backdrop") onClose(); });
  q("#am-close").addEventListener("click", onClose);
  q("#am-signout").addEventListener("click", onSignOut);
  q("#am-save").addEventListener("click", async () => {
    const btn = q("#am-save");
    try {
      await api.saveDfs(q("#am-login").value.trim(), q("#am-password").value.trim(), parseInt(q("#am-location").value, 10) || 2840);
      btn.textContent = "Saved ✓";
      setTimeout(() => onSaveDfs(true), 600);
    } catch (err) {
      const errBox = q("#am-err");
      errBox.style.display = "block";
      errBox.textContent = err.message;
    }
  });
  const removeBtn = q("#am-remove");
  if (removeBtn) removeBtn.addEventListener("click", async () => {
    try { await api.removeDfs(); } catch { /* stay open on failure */ }
    onSaveDfs(false);
  });
}
